import { render, staticRenderFns } from "./UpdateBank.vue?vue&type=template&id=50cdf662&scoped=true&"
import script from "./UpdateBank.vue?vue&type=script&lang=js&"
export * from "./UpdateBank.vue?vue&type=script&lang=js&"
import style0 from "./UpdateBank.vue?vue&type=style&index=0&id=50cdf662&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cdf662",
  null
  
)

export default component.exports